/* BISSO — Theme JS. Klein halten, nichts blockieren. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Scroll Reveal ---------------- */
  (function reveal() {
    var els = [].slice.call(document.querySelectorAll('.rv'));
    if (!els.length) return;

    function showAll() { els.forEach(function (e) { e.classList.add('in'); }); }

    if (reduce || !('IntersectionObserver' in window)) { showAll(); return; }

    /* Primär: IntersectionObserver */
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });
    els.forEach(function (e) { io.observe(e); });

    /* Fallback: einfacher Rect-Check bei Scroll/Resize.
       Falls der Observer aus irgendeinem Grund nicht auslöst,
       bleibt kein Inhalt unsichtbar. */
    var ticking = false;
    function check() {
      ticking = false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = els.length - 1; i >= 0; i--) {
        var el = els[i];
        if (el.classList.contains('in')) { els.splice(i, 1); continue; }
        var r = el.getBoundingClientRect();
        if (r.top < vh - 40 && r.bottom > 0) { el.classList.add('in'); els.splice(i, 1); }
      }
      if (!els.length) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();

    /* Letzte Sicherung: nach 3 s ist alles sichtbar, egal was passiert ist. */
    setTimeout(function () {
      document.querySelectorAll('.rv:not(.in)').forEach(function (e) { e.classList.add('in'); });
    }, 3000);
  })();

  /* ---------------- Mobile Drawer ---------------- */
  (function drawer() {
    var d = document.querySelector('[data-drawer]');
    if (!d) return;
    var opener = document.querySelector('[data-drawer-open]');
    function open() {
      d.hidden = false;
      requestAnimationFrame(function () { d.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      if (opener) opener.setAttribute('aria-expanded', 'true');
    }
    function close() {
      d.classList.remove('is-open');
      document.body.style.overflow = '';
      if (opener) opener.setAttribute('aria-expanded', 'false');
      setTimeout(function () { d.hidden = true; }, 360);
    }
    if (opener) opener.addEventListener('click', open);
    d.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.classList.contains('is-open')) close(); });
  })();

  /* ---------------- Galerie ---------------- */
  (function gallery() {
    var main = document.querySelector('[data-gal-main]');
    if (!main) return;
    var slides = main.querySelectorAll('[data-gal-slide]');
    var thumbs = document.querySelectorAll('[data-gal-thumb]');

    function show(i) {
      for (var k = 0; k < slides.length; k++) {
        slides[k].classList.toggle('is-active', k === i);
        if (k !== i) {
          var vid = slides[k].querySelector('video');
          if (vid) { try { vid.pause(); } catch (e) {} }
        }
      }
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', String(Number(t.getAttribute('data-gal-thumb')) === i));
      });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(Number(t.getAttribute('data-gal-thumb'))); });
    });
  })();

  /* ---------------- Produkt: Varianten, Preis, Sticky ---------------- */
  (function product() {
    var form = document.getElementById('pdp-form');
    if (!form) return;

    var select = form.querySelector('[data-variant-select]');
    if (!select) return;

    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var saveEl = document.querySelector('[data-save]');
    var addBtn = form.querySelector('[data-add]');
    var addText = form.querySelector('[data-add-text]');
    var stickyPrice = document.querySelector('[data-sticky-price]');

    var opts = Array.prototype.slice.call(select.options);

    function money(cents) {
      /* Geschuetztes Leerzeichen: sonst rutscht das Eurozeichen beim Umbruch
         allein in die naechste Zeile. */
      return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }

    /* Aktuelle Auswahl je Option-Index */
    function currentValues() {
      var o = opts[select.selectedIndex];
      return [o.getAttribute('data-opt1') || '', o.getAttribute('data-opt2') || '', o.getAttribute('data-opt3') || ''];
    }

    function findVariant(vals) {
      for (var i = 0; i < opts.length; i++) {
        var o = opts[i];
        var a = o.getAttribute('data-opt1') || '';
        var b = o.getAttribute('data-opt2') || '';
        var c = o.getAttribute('data-opt3') || '';
        if ((!vals[0] || a === vals[0]) && (!vals[1] || b === vals[1]) && (!vals[2] || c === vals[2])) return i;
      }
      return -1;
    }

    function render() {
      var o = opts[select.selectedIndex];
      if (!o) return;
      var price = Number(o.getAttribute('data-price') || 0);
      var comp = Number(o.getAttribute('data-compare') || 0);

      if (priceEl) priceEl.textContent = money(price);
      if (stickyPrice) stickyPrice.textContent = money(price);

      if (compareEl) {
        if (comp > price) {
          compareEl.textContent = money(comp);
          compareEl.classList.remove('hide');
          if (saveEl) {
            saveEl.textContent = 'Sie sparen ' + money(comp - price);
            saveEl.classList.remove('hide');
          }
        } else {
          compareEl.classList.add('hide');
          if (saveEl) saveEl.classList.add('hide');
        }
      }

      var avail = !o.disabled;
      if (addBtn) addBtn.disabled = !avail;
      if (addText) addText.textContent = avail ? 'In den Warenkorb' : 'Derzeit nicht verfügbar';

      /* Galerie auf das Bild der Variante stellen.
         Die Farbwahl schaltete zwar die Variante um, das Foto blieb aber auf
         Mint stehen. Wer auf Gruen tippte, sah keinerlei Reaktion und hielt
         die Farbwahl fuer kaputt. Shopify kennt die Zuordnung bereits, das
         Theme hat sie nur nie ausgelesen. */
      var medienId = o.getAttribute('data-media');
      if (medienId) {
        var ziel = document.querySelector('.gal__slide[data-media-id="' + medienId + '"]');
        if (ziel && !ziel.classList.contains('is-active')) {
          document.querySelectorAll('.gal__slide').forEach(function (sl) { sl.classList.remove('is-active'); });
          ziel.classList.add('is-active');
          var i = ziel.getAttribute('data-gal-slide');
          document.querySelectorAll('.gal__thumb').forEach(function (t) {
            t.setAttribute('aria-current', String(t.getAttribute('data-gal-thumb') === i));
          });
          var aktiv = document.querySelector('.gal__thumb[data-gal-thumb="' + i + '"]');
          if (aktiv && aktiv.scrollIntoView) aktiv.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }
      }

      var vals = currentValues();

      /* Farbwahl der gewaehlten Karte zeigen, alle anderen stilllegen.
         Nur die sichtbaren Felder duerfen mitgeschickt werden — deaktivierte
         Felder sendet der Browser nicht, sonst stuenden im Auftrag Farben zu
         einer Menge, die gar nicht gekauft wurde. */
      var farbBloecke = document.querySelectorAll('[data-tier-colors]');
      if (farbBloecke.length) {
        var ersterPick = document.querySelector('.tier__pick[data-opt]');
        var mengeIdx = ersterPick ? Number(ersterPick.getAttribute('data-opt')) : -1;
        var aktuelleStufe = mengeIdx >= 0 ? vals[mengeIdx] : '';
        farbBloecke.forEach(function (blk) {
          var zeigen = blk.getAttribute('data-tier-colors') === aktuelleStufe;
          blk.hidden = !zeigen;
          blk.querySelectorAll('select').forEach(function (feld) {
            feld.disabled = !zeigen;
            if (zeigen && feld.hasAttribute('data-color-primary')) {
              var ci = Number(feld.getAttribute('data-opt-index'));
              if (!isNaN(ci) && vals[ci] && feld.value !== vals[ci]) feld.value = vals[ci];
            }
          });
        });
      }

      /* Button-Zustände synchronisieren */
      document.querySelectorAll('[data-opt]').forEach(function (btn) {
        var idx = Number(btn.getAttribute('data-opt'));
        var an = btn.getAttribute('data-val') === vals[idx];
        btn.setAttribute('aria-checked', String(an));
        var karte = btn.closest ? btn.closest('.tier') : null;
        if (karte) karte.classList.toggle('is-on', an);
      });
      document.querySelectorAll('[data-option-current]').forEach(function (el) {
        var idx = Number(el.getAttribute('data-option-current'));
        el.textContent = vals[idx] || '';
      });
    }

    /* Preise/Ersparnis in die Stufen-Karten schreiben */
    (function fillTiers() {
      var cards = document.querySelectorAll('[data-tier-price]');
      if (!cards.length) return;
      var base = null;
      cards.forEach(function (el) {
        var val = el.getAttribute('data-tier-price');
        var btn = document.querySelector('.tier__pick[data-val="' + CSS.escape(val) + '"]');
        if (!btn) return;
        var idx = Number(btn.getAttribute('data-opt'));
        var vals = currentValues();
        vals[idx] = val;
        var vi = findVariant(vals);
        if (vi < 0) return;
        var price = Number(opts[vi].getAttribute('data-price') || 0);
        el.textContent = money(price);

        var qty = parseInt(val, 10);
        if (!isNaN(qty)) {
          if (qty === 1) base = price;
          var desc = btn.querySelector('[data-tier-desc="' + CSS.escape(val) + '"]');
          if (desc) {
            if (qty > 1 && base) {
              var save = base * qty - price;
              desc.textContent = save > 0
                ? money(price / qty) + ' pro Stück · ' + money(save) + ' günstiger als ' + qty + ' einzeln'
                : money(price / qty) + ' pro Stück';
            } else {
              desc.textContent = 'Einzelner Kaustick';
            }
          }
        }
      });
    })();

    function waehle(idx, wert) {
      if (isNaN(idx) || idx < 0) return;
      var vals = currentValues();
      vals[idx] = wert;
      var vi = findVariant(vals);
      if (vi < 0) return;
      select.selectedIndex = vi;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      var url = new URL(window.location.href);
      url.searchParams.set('variant', opts[vi].value);
      window.history.replaceState({}, '', url);
    }

    document.querySelectorAll('[data-opt]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        waehle(Number(btn.getAttribute('data-opt')), btn.getAttribute('data-val'));
      });
    });

    /* Die erste Farbe einer Karte ist die Farbe der Variante — sie schaltet
       um wie ein Farbknopf. Jede weitere geht als Bestellhinweis mit. */
    document.querySelectorAll('[data-color-primary]').forEach(function (feld) {
      feld.addEventListener('change', function () {
        waehle(Number(feld.getAttribute('data-opt-index')), feld.value);
      });
    });

    select.addEventListener('change', render);
    render();

    /* Sticky CTA */
    var sticky = document.querySelector('[data-sticky]');
    if (sticky && addBtn) {
      var stickyAdd = sticky.querySelector('[data-sticky-add]');
      if (stickyAdd) stickyAdd.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var on = !en.isIntersecting && en.boundingClientRect.top < 0;
            sticky.classList.toggle('is-on', on);
            sticky.setAttribute('aria-hidden', String(!on));
          });
        }, { threshold: 0 });
        io.observe(addBtn);
      }
    }
  })();

  /* ---------------- Warenkorb: Menge ---------------- */
  (function cartQty() {
    document.querySelectorAll('[data-qty]').forEach(function (box) {
      var input = box.querySelector('input');
      if (!input) return;
      box.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var step = b.getAttribute('data-step') === 'up' ? 1 : -1;
          var val = Math.max(0, (parseInt(input.value, 10) || 0) + step);
          input.value = val;
          var f = input.closest('form');
          if (f) (f.requestSubmit ? f.requestSubmit() : f.submit());
        });
      });
    });
  })();

  /* ---------------- Videos erst laden, wenn sie gebraucht werden ----------
     Vorher stand die Quelle im Markup und autoplay hat sie sofort gezogen —
     auf der Produktseite gut drei Megabyte, bevor jemand ueberhaupt
     gescrollt hat. Jetzt steht sie in data-lazysrc und wird 400 px vor dem
     Sichtbereich gesetzt. Bei reduzierter Bewegung bleibt das Standbild. */
  (function lazyVideos() {
    var vids = Array.prototype.slice.call(document.querySelectorAll('video[data-lazysrc]'));
    if (!vids.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    var start = function (v) {
      if (v.getAttribute('data-started')) return;
      v.setAttribute('data-started', '1');
      v.src = v.getAttribute('data-lazysrc');
      v.load();
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    };
    if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { start(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '400px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  })();

})();
